module.exports = "<div class=\"wrapper\">\n  <div class=\"bg-container\">\n    <a routerLink=\"/search\">\n      <div class=\"spacer\">\n        &nbsp;\n      </div>\n    </a>\n  </div>\n\n  <div class=\"popular\">\n    <popular-section></popular-section>\n  </div>\n</div>\n\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main